import {assetIsPresent} from '@netx/core-asset-next/enablers/assetIsPresent';
import {
	currentUserMeetsUserLevel,
	UserLevel,
} from '@netx/core-user-next/utils/currentUserMeetsUserLevel';
import {
	assetPermissionChecker,
	PermissionName,
	PermissionMatrixName,
} from '@netx/core-permissions-next';
import {type IAsset} from '../schema';

export const canCreateShareLinkPdfFromAsset = (asset?: IAsset): boolean => {
	if (asset == null) return false;
	if (!currentUserMeetsUserLevel(UserLevel.CONSUMER)) return false;
	if (!assetIsPresent(asset)) return false;
	return assetPermissionChecker({
		asset,
		permissionMatrixName: PermissionMatrixName.DOWNLOAD,
		permissionName: PermissionName.CREATE_SHARE_LINKS,
	});
};
